import { extendTheme } from '@chakra-ui/react';

const theme = extendTheme({
  breakpoints: {
    lg: '950px',
  },
  colors: {
    black: '#000000',
    white: '#FFFFFF',
    lightGreen: '#3DD13D',
    red: '#FF0000',
    redDark: '#C80000',
    neutralLight: '#F0F0F0',

    buttonBackground: '#E2E8F0',
    buttonHover: '#D5DFEB',
    buttonClick: '#CBD5E0',

    characterDeath: '#B5A7DB',
    characterDeathShadow: '#3E8A51',

    leftSideDark: '#1E78D7',
    leftSideMain: '#1E90FF',
    leftSideLight: '#BBDEFF',
    leftSideMedium: '#7DC4FF',
    leftSide: {
      100: '#BBDEFB',
      500: '#1E90FF',
    },
    rightSideDark: '#D7553C',
    rightSideMain: '#FF6347',
    rightSideLight: '#FFCDD2',
    rightSideMedium: '#FF8E7A',
    rightSide: {
      100: '#FFCDD2',
      500: '#FF6347',
    },
    luckPointMain: '#FCBA03',
    luckPointLight: '#FCD569',
    luckPoint: {
      100: '#FCD569',
      500: '#FCBA03',
      800: '#DBA203',
    },
  },
});

export default theme;
